<template>
  <div id="login_page" :style="loginPageBG">
    <el-container>
      <!--<el-header>
        <div class="header-content">
          <span @click="goHomePage">logo</span>
          <span @click="goHomePage">首页</span>
          <span>求职</span>
          <span>招聘</span>
          <span class="about-us">关于我们</span>
        </div>
      </el-header>-->
      <!--      <header-component></header-component>-->
      <div class="el-main">
        <div class="main-content">
          <div class="login-form" v-if="!isResetPassword">
            <div class="logo" :style="logoContent"></div>
            <register-dialog :isRegister="isRegister" @closeRegisterDialog="closeDialogAndConfirm"></register-dialog>
            <el-tabs v-model="loginType" @tab-click="activeTab">
              <el-tab-pane label="密码登录" name="passwordLogin">
                <el-form :model="userInfo1" :size="'medium'" label-width="110px" :rules="userInfoRules" ref="userInfo1">
                  <el-form-item label="" prop="userName" v-if="!codeForLogin">
                    <el-input v-model="userInfo1.userName" prefix-icon="el-icon-user" placeholder="输入用户名、手机号或邮箱"
                              clearable></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="password" v-if="!codeForLogin">
                    <el-input v-model="userInfo1.password" prefix-icon="el-icon-key" placeholder="输入密码" @keyup.enter.native="submitForLogin()"
                              show-password></el-input>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="验证码登录" name="codeLogin">
                <el-form :model="userInfo2" :size="'medium'" label-width="110px" :rules="userInfoRules" ref="userInfo2">
                  <el-form-item label="" prop="phone_email">
                    <el-input v-model="userInfo2.phone_email" ref="phone_email" prefix-icon="el-icon-user"
                              placeholder="手机号或邮箱" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="loginVerificationCode">
                    <el-input ref="loginVerificationCode" v-model="userInfo2.loginVerificationCode"
                              class="login-verification-code"
                              prefix-icon="el-icon-message" @keyup.enter.native="submitForLogin()" placeholder="输入验证码">
                      <el-button v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码
                      </el-button>
                      <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
                    </el-input>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <el-button type="primary" @click="submitForLogin()" style="width: 100%">登录</el-button>
            <div class="other-operate">
              <span>还没账号？</span>
              <i class="el-icon-right">&nbsp;</i>
<!--              <span class="fast-register" @click="isRegister = true">快速注册</span>-->
              <span class="fast-register" @click="goRegisterPage()">快速注册</span>
              <span class="forget-password" @click="isResetPassword = true">忘记密码?</span>
            </div>
          </div>

          <div class="login-form reset-password" v-else>
            <div class="reset-back" @click="backToLogin()"><i class="el-icon-arrow-left"></i>返回</div>
            <el-form :model="userInfo3" :size="'medium'" label-width="110px" :rules="userInfoRules" ref="userInfo3">
              <el-form-item label="" prop="number">
                <el-input v-model="userInfo3.number" ref="number" prefix-icon="el-icon-user"
                          placeholder="手机号或邮箱" clearable></el-input>
              </el-form-item>
              <el-form-item label="" prop="code">
                <el-input ref="code" v-model="userInfo3.code"
                          class="login-verification-code"
                          prefix-icon="el-icon-message" placeholder="输入验证码">
                  <el-button v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码
                  </el-button>
                  <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input v-model="userInfo3.password" prefix-icon="el-icon-key" placeholder="输入密码"
                          show-password></el-input>
              </el-form-item>
              <el-form-item label="" prop="passwordConfirm">
                <el-input v-model="userInfo3.passwordConfirm" prefix-icon="el-icon-key" placeholder="确认密码"
                          show-password></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="submitResetPassword()" style="width: 100%">重置密码</el-button>
          </div>

          <div class="register-content"></div>
        </div>
      </div>
      <el-footer height="40px">Copyright © 2022 www.hangzhourenge.cn 浙ICP备2022018352号-2</el-footer>
    </el-container>
  </div>
</template>

<script>// import HeaderComponent from './Head/HeaderComponent'

import utilService from '../utils/utilService'
import RegisterDialog from './Register/RegisterDialog'

export default {
  name: 'Login',
  components: {RegisterDialog},
  data () {
    // 手机号或邮箱校验
    let validatePhoneOrEmail = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value.trim())) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(value.trim()))) {
        callback(new Error('请输入正确的手机号码或邮箱'))
      }
      callback()
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (!(/^\d{6}$/.test(value.trim()))) {
        callback(new Error('请输入6位正确的验证码'))
      }
      callback()
    }
    // 用户名校验 /^[a-zA-Z0-9_-]{4,20}$/ 用户名由英文字母，数字及下划线组成，长度4-20位
    // let validateUserName = (rule, value, callback) => {
    //   if (!(/^[a-zA-Z0-9_-]{4,20}$/.test(value.trim()))) {
    //     callback(new Error('用户名由英文字母，数字及下划线组成，长度4-20位'))
    //   }
    //   callback()
    // }
    // 密码正则校验
    let validatePass = (rule, value, callback) => {
      if (!/^[\w_-]{6,20}$/.test(value.trim())) {
        callback(new Error('请输入6-20位字母、数字或特殊字符(-_)作为密码'))
      }
      callback()
    }
    // 密码确认
    let validatePass2 = (rule, value, callback) => {
      if (this.userInfo3.password.trim() !== this.userInfo3.passwordConfirm.trim()) {
        callback(new Error('两次输入密码不一致'))
      }
      callback()
    }
    return {
      isResetPassword: false,
      loginNumber: '',
      loginVerificationCode: '',
      verificationCodeFlag: true,
      waitingCodeTime: 60,
      roleNum: 'ROLE0002',
      /* roleNum: {
        ROLE0002: '',// enterprise
        ROLE0001: '',// jobseeker
        ROLE0000: ''// admin
      } */
      // loginPageLoading: false
      loginType: 'passwordLogin',
      userInfo: {
        roleNum: 'ROLE0002',
        phone_email: '',
        loginVerificationCode: '',
        userName: '',
        passWord: ''
      },
      userInfo1: {
        userName: '',
        password: ''
      },
      userInfo2: {
        phone_email: '',
        loginVerificationCode: ''
      },
      userInfo3: {
        number: '',
        code: '',
        password: '',
        passwordConfirm: ''
      },
      userInfoRules: {
        phone_email: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        number: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '输入用户名、手机号或邮箱', trigger: 'blur'}
          // {validator: validateUserName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        loginVerificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ],
        passwordConfirm: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ]
      },
      codeForLogin: false,
      isRegister: false,
      loginPageBG: {
        backgroundImage: `url(${require('../assets/login_bg1.jpg')})`,
        width: '100vw',
        height: '100vh',
        backgroundSize: 'cover'
      },
      logoContent: {
        backgroundImage: `url(${require('../assets/logo.jpg')})`,
        width: '60px',
        height: '60px',
        backgroundSize: 'cover',
        position: 'relative',
        left: 'calc(50% - 20px)'
      }
    }
  },
  methods: {
    checkPhoneNumberAddSendMsg () {
      let form = this.isResetPassword ? 'userInfo3' : 'userInfo2'
      let number = this.isResetPassword ? 'number' : 'phone_email'

      this.$refs[form].validateField(number, (errMsg) => {
        if (!errMsg) {
          this.verificationCodeFlag = false
          if (this.isResetPassword) {
            this.$refs.code.focus()
          } else {
            this.$refs.loginVerificationCode.focus()
          }
          let timer = setInterval(() => {
            this.waitingCodeTime--
            if (this.waitingCodeTime === 0) {
              this.waitingCodeTime = 60
              clearInterval(timer)
              this.verificationCodeFlag = true
            }
          }, 1000)
          // 调接口发送验证码
          let param = {number: ''}
          param.number = this.isResetPassword ? this.userInfo3.number : this.userInfo2.phone_email
          this.$http.get(this.$api.getVerificationCode.url, param).then(res => {
            console.log(res)
          })
        } else {
          if (this.isResetPassword) {
            this.$refs.number.focus()
          } else {
            this.$refs.phone_email.focus()
          }
        }
      })
    },
    registerAndLogin () {
      console.log(this.loginNumber)
      console.log(this.loginVerificationCode)
      if (!(/^1[3456789]\d{9}$/.test(this.loginNumber)) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(this.loginNumber))) {
        this.$message.error({
          message: '请输入正确的手机号码或邮箱',
          center: true
        })
        this.$refs.loginNumber.focus()
      } else if (this.loginVerificationCode.length === 0) {
        this.$message.warning({
          message: '请输入短信验证码',
          center: true
        })
        this.$refs.loginVerificationCode.focus()
        return false
      } else {
        // this.loginPageLoading = true
        const loading = this.$loading({
          lock: true,
          text: '登录中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.2)',
          target: '.login-form'
        })

        /**
         * 调接口注册或登录, 若验证码错误，则进行提示，验证OK则进入系统
         * */
        this.$http.post(this.$api.registerOrLogin.url, {
          'number': this.loginNumber,
          'code': this.loginVerificationCode,
          'roleNum': this.roleNum
        }).then(res => {
          if (res && res.code === 200) {
            // 登录成功缓存用户在线会话ID
            this.$store.set('Authorization', res.data)
            this.$store.session.set('Authorization', res.data)
            this.$cookies.config('15d')
            this.$cookies.set('user_session', res.data, '15d')
            this.$http.get(this.$api.getCurrentUserInfoByCode.url, {
              userCode: res.data
            }).then(userInfoRes => {
              if (userInfoRes && userInfoRes.code === 200) {
                this.$store.set('user', userInfoRes.data)
                this.$store.session.set('user', userInfoRes.data)
                loading.close()
                this.$router.push({
                  name: 'Home',
                  params: {}
                })
              }
              if (userInfoRes.code !== 200 && userInfoRes.msg) {
                this.$message.warning(userInfoRes.msg)
              }
            })
          }
        }).catch(res => {
          console.log(res)
        }).finally(res => {
          setTimeout(() => {
            loading.close()
          }, 1000)
        })
      }
    },
    goHomePage () {
      this.$router.push({
        name: 'Home',
        params: null
      })
    },
    goRegisterPage () {
      this.$router.push({
        name: 'RegisterUser',
        params: null
      })
    },
    /* changeLoginType (flag) {
      this.$refs['userInfo'].resetFields()
      this.codeForLogin = flag
    }, */
    activeTab (tab, event) {
      if (this.loginType === 'passwordLogin') {
        this.$refs['userInfo2'].resetFields()
      } else {
        this.$refs['userInfo1'].resetFields()
      }
    },
    submitForLogin () {
      if (this.loginType === 'passwordLogin') {
        this.$refs['userInfo1'].validate((valid) => {
          if (valid) {
            this.$http.post(this.$api.loginUser.url, this.userInfo1).then(res => {
              if (res && res.code === 200) {
                this.$cookies.set('user_session', res.data['entryCode'], '15d')
                this.$store.set('Authorization', res.data['entryCode'])
                this.$store.session.set('Authorization', res.data['entryCode'])
                this.$store.set('user', res.data)
                this.$store.session.set('user', res.data)
                this.$router.push({
                  name: 'Home',
                  params: null
                })
              } else if (res.msg) {
                this.$message.warning(res.msg)
              }
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs['userInfo2'].validate((valid) => {
          if (valid) {
            this.$http.post(this.$api.loginUser.url, {
              number: this.userInfo2.phone_email,
              code: this.userInfo2.loginVerificationCode
            }).then(res => {
              if (res && res.code === 200) {
                this.$cookies.set('user_session', res.data['entryCode'], '7d')
                this.$store.set('Authorization', res.data['entryCode'])
                this.$store.session.set('Authorization', res.data['entryCode'])
                this.$store.set('user', res.data)
                this.$store.session.set('user', res.data)
                this.$router.push({
                  name: 'Home',
                  params: null
                })
              } else if (res.msg) {
                this.$message.warning(res.msg)
              }
            })
          } else {
            return false
          }
        })
      }
    },
    closeDialogAndConfirm () {
      this.isRegister = false
    },
    submitResetPassword () {
      this.$refs['userInfo3'].validate((valid) => {
        if (valid) {
          /**
           * 调就接口重置用户密码
           * */
          this.$http.put(this.$api.updatePassword.url, {
            number: this.userInfo3.number,
            code: this.userInfo3.code,
            newPassword: this.userInfo3.password
          }).then(res => {
            if (res && res.code === 200) {
              this.userInfo3 = {
                number: '',
                code: '',
                password: '',
                passwordConfirm: ''
              }
              this.isResetPassword = false
              this.$message.success('密码重置成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    backToLogin () {
      this.userInfo3 = {
        number: '',
        code: '',
        password: '',
        passwordConfirm: ''
      }
      this.isResetPassword = false
    }

  },
  calculate: {},
  mounted () {
  },
  created () {
    /**
     * 根据cookie调接口校验用户是否过期，未过期则进入首页，否则进入登录页
     * */
    if (this.$cookies.get('user_session')) {
      this.$store.set('Authorization', this.$cookies.get('user_session'))
      this.$store.session.set('Authorization', this.$cookies.get('user_session'))

      this.$http.get(this.$api.getCurrentUserInfoByCode.url, {
        userCode: this.$cookies.get('user_session')
      }).then(userInfoRes => {
        if (userInfoRes && userInfoRes.code === 200) {
          this.$store.set('user', userInfoRes.data)
          this.$store.session.set('user', userInfoRes.data)
          this.currentUser = userInfoRes.data
          utilService.currentUser = userInfoRes.data
          this.$router.push({
            name: 'Home',
            params: null
          })
        }
        if (userInfoRes.code !== 200 && userInfoRes.msg) {
          this.$message.warning(userInfoRes.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
  #login_page {
    height: calc(100vh);
    min-height: 768px;
  }

  .header-content, .main-content {
    width: 1200px;
    margin: auto;
    text-align: left;
    /*height: calc(100vh - 260px);*/
  }

  .el-footer {
    /*background-color: #f0f2f5;*/
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    height: 40px;
  }

  .el-main {
    /*background-color: #E9EEF3;*/
    color: #333;
    text-align: center;
    height: calc(100vh - 40px);
    background-size: cover;
  }

  body > .el-container {
    width: 1000px;
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

  .login-form {
    background: #ffffff;
    width: 330px;
    height: 380px;
    float: right;
    box-shadow: 1px 2px 15px rgba(0, 0, 0, .3);
    border-radius: 2px;
    text-align: left;
    padding: 20px 35px 0;
    margin-top: 180px;
  }

  .el-input {
    margin: auto;
  }

  .el-input-group__append button:hover {
    background: #409EFF;
    color: #ffffff;
  }

  .login-btn {
    width: 100%;
  }

  .login-verification-code button {
    border-radius: 0;
  }

  /deep/ .el-radio-button__inner, .el-radio-group {
    width: 100%;
  }

  .el-radio-button {
    width: 50%;
  }

  /deep/ .el-tabs__nav {
    width: 100%;
    text-align: center;
  }

  /deep/ .el-tabs__item {
    width: 50%;
    padding: 0;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-form-item {
    margin-bottom: 40px;
  }

  .other-operate {
    margin-top: 20px;
  }

  .fast-register {
    color: #409EFF;
    cursor: pointer;
  }

  .forget-password {
    float: right;
    color: #409EFF;
    cursor: pointer;
  }

  .fast-register:hover, .forget-password:hover {
    text-decoration: underline;
  }
  .reset-password .el-form-item {
    margin-bottom: 25px;
  }

  .reset-back {
    margin-bottom: 10px;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
    display: inline-block;
  }
  .reset-back:hover {
    text-decoration: underline;
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue